import axios from 'axios';
import { adminApi } from '@/lib/adminApi';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true, headers: { 'Content-Type': 'application/json' } });
const d = (p) => p.then((r) => r.data);

export const founderApi = {
  requestLink: (email) => d(http.post('/founder/auth/request-link', { email })),
  verify: (token) => d(http.post('/founder/auth/verify', { token })),
  logout: () => d(http.post('/founder/auth/logout')),
  workspace: () => d(http.get('/founder/workspace')),
  blueprint: (bid) => d(http.get(`/founder/blueprints/${bid}`)),
  document: (bid) => d(http.get(`/founder/blueprints/${bid}/document`)),
  pdfUrl: (bid) => `${API}/founder/blueprints/${bid}/pdf`,
  saveStage: (bid, stage, version, answers) => d(http.patch(`/founder/blueprints/${bid}/stages/${stage}`, { version, answers })),
  completeStage: (bid, stage, version) => d(http.post(`/founder/blueprints/${bid}/stages/${stage}/complete`, { version })),
  resolveLink: (bid, target, action, version) => d(http.post(`/founder/blueprints/${bid}/links`, { target, action, version })),
  info: () => d(http.get('/founder-blueprint/info')),
  checkout: (body) => d(http.post('/founder-blueprint/checkout', body)),
  orderStatus: (sessionId) => d(http.get('/founder-blueprint/order-status', { params: { session_id: sessionId } })),
  resendForSession: (sessionId) => d(http.post('/founder-blueprint/order-status/resend-access', { session_id: sessionId })),
};

const A = '/admin/founder-blueprint';
export const founderAdminApi = {
  overview: () => d(adminApi.get(`${A}/overview`)),
  entitlements: (params = {}) => d(adminApi.get(`${A}/entitlements`, { params })),
  entitlement: (id) => d(adminApi.get(`${A}/entitlements/${id}`)),
  action: (id, action, reason) => d(adminApi.post(`${A}/entitlements/${id}/${action}`, reason ? { reason } : {})),
  issues: () => d(adminApi.get(`${A}/fulfillment-issues`)),
  retry: (oid) => d(adminApi.post(`${A}/orders/${oid}/retry`)),
  liveTestCheckout: () => d(adminApi.post(`${A}/live-test-checkout`)),
  liveTestDisable: () => d(adminApi.post(`${A}/live-test/disable`)),
  setSaleMode: (sale_mode) => d(adminApi.post(`${A}/sale-mode`, { sale_mode })),
  testCheckout: (body) => d(adminApi.post(`${A}/test-checkout`, body)),
};
